import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../generic-components/Button';
import { STYLE, TEXT } from '../constants';

const { PAGES: { POST_LINKED: { MONEY_TRANSFER: { CONFIRMATION_MODAL_CONTENT: { TRANSFER_ACTIONS } } } } } = STYLE;
const { PAGES: { POST_LINKED: { MONEY_TRANSFER: { USER_MESSAGE } } } } = TEXT;

interface IProps {
    isConfirmable: boolean;
    onConfirmation: () => void;
    onCancel: () => void;
    isLoading: boolean;
    isError: boolean;
}

export const TransferActions = ({
  isConfirmable, onConfirmation, onCancel, isLoading, isError,
}: IProps) => {
  const { t } = useTranslation();
  const handleConfirmation = () => {
    onConfirmation();
  };
  return (
    <div className={TRANSFER_ACTIONS.WRAPPER}>
      <Button onClick={() => onCancel()} className={TRANSFER_ACTIONS.CANCEL} id='' title={t(USER_MESSAGE.CTA_CANCEL)} />
      <Button isLoading={isLoading} disable={!isConfirmable || isError} onClick={handleConfirmation} className={(isConfirmable && !isError) ? TRANSFER_ACTIONS.CONFIRM_ENABLE : TRANSFER_ACTIONS.CONFIRM_DISABLE} id='' title={t(USER_MESSAGE.CTA_CONFIRM)} />
    </div>
  );
};
